import React, { Component } from 'react';
import Field from '../util/field/Field';
import Dropdown from '../util/dropdown/Dropdown';
import { toast } from 'react-toastify';
import Loading from '../util/loading/Loading';
import SatAPI from '../../services/Sat';
import ErrorMessages from '../../util/validation-error-messages';
import ExpresionesRegulares from '../../util/expresiones-regulares';
import { Formik } from 'formik';
import * as Yup from 'yup';


class EstacionCocinaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estacionCocina: { ...this.props.estacionCocina },
            isEditing: false,
            satCodes: [],
            isLoading: false,
            showModal: false
        }
    }

    VALIDATION_SCHEMA = Yup.object({
        Descripcion: Yup.string()
            .trim()
            .matches(ExpresionesRegulares.AlfanumericoSinEspeciales, { message: ErrorMessages.AlfanumericoSinEspecialesError })
            .min(3, "Descripción debe tener más de 2 caracteres.")
            .max(50, "Ha excedido el límite de 50 caracteres.")
            .required("Campo Descripción es requerido.")
    });

    render() {
        return (
            <Formik
                initialValues={this.state.estacionCocina}
                validationSchema={this.VALIDATION_SCHEMA}
                onSubmit={(values) => {     
                    let formatValues = {...values}
                    formatValues.Descripcion =  formatValues.Descripcion.trim();        
                    this.props.save(formatValues)                    
                }}
            >
                {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <Field 
                                label="Descripcion"
                                isHorizontal
                                hasError = {errors.Descripcion && touched.Descripcion}
                                msgError = {errors.Descripcion && touched.Descripcion ? errors.Descripcion : ""}
                                showLeftSpaces = {true}                                
                                childInfo = {values.Descripcion && !errors.Descripcion ? `Te quedan ${50 - values.Descripcion.trim().length} caracteres para la descripcion.`  : ""}
                            >
                                <input
                                    id="descripcion"
                                    name={"Descripcion"}
                                    className={`input ${errors.Descripcion && touched.Descripcion ? "is-danger" : ""}`}
                                    placeholder={"Ingrese descripcion de la estacion de cocina"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.Descripcion}
                                />
                            </Field>

                            <div className="has-text-right buttons-modal">
                                <div className="column">
                                    <button type="submit" className="button is-success" >
                                        Guardar
                                </button>
                                </div>
                            </div>
                        </div>
                        
                        <Loading isFullscreen={true} isLoading={this.state.isLoading} width='100px' height='100px' />
                    </form>
                )}

            </Formik>            
        );
    }
}

EstacionCocinaForm.defaultProps = {
    isEditing: false,
    estacionCocina: {
        Descripcion: "",
    }
}

export default EstacionCocinaForm;
